// URL base del backend PHP (sin el "?url=" final).
// En desarrollo local usa localhost/Laragon. En producción se toma de la
// variable de entorno VITE_API_URL definida en frontend/.env.production
// (ej: VITE_API_URL=https://tudominio.com/Tournament/public/index.php)
export const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/Tournament/public/index.php'

// Cantidad de tatamis físicos disponibles (debe coincidir con TOTAL_TATAMIS en config/config.php)
export const TOTAL_TATAMIS = 3

// Carpeta base del backend (donde vive /uploads), derivada de API_URL quitando "index.php"
// ej: http://localhost/Tournament/public/  ó  https://torneo.moleint.com/backend/public/
export const ASSETS_BASE_URL = API_URL.replace(/index\.php$/, '')

// Arma la URL final de una foto/logo a partir de lo guardado en la BD (foto_url).
// - Si ya es una URL absoluta (http/https), se usa tal cual (ej. links viejos de Google Drive).
// - Si es una ruta relativa (ej. "uploads/competidores/COMP-001.jpg"), se le agrega la base del backend.
// - Si viene vacío/null, retorna null (el componente debe mostrar su fallback, ej. un emoji).
export function getFotoUrl(fotoUrl) {
  if (!fotoUrl) return null
  if (/^https?:\/\//i.test(fotoUrl)) return fotoUrl
  return `${ASSETS_BASE_URL}${fotoUrl.replace(/^\//, '')}`
}
